import { useEffect } from 'react';

import { isBrowser } from 'utils/UserAgent';

export const scrollbarWidthProp = '--scrollbar-width';

/**
 * A hook for capturing the scrollbar width when its available
 */
export function useCaptureScrollbar() {
  useEffect(() => {
    if (!isBrowser) return;

    const hasResizeObserver = 'ResizeObserver' in window;

    if (!hasResizeObserver) return;

    const resizeObserver = new ResizeObserver(() => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.setProperty(scrollbarWidthProp, `${scrollbarWidth}px`);

        // Disconnect as once we have the scrollbar width, we don't need to keep recalculating it
        if (resizeObserver) {
          resizeObserver.disconnect();
        }
      }
    });

    resizeObserver.observe(document.body);

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, []);
}
